import {
  Component,
  OnInit,
  Input,
  TemplateRef,
  Output,
  EventEmitter,
  OnDestroy
} from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { ToastrService } from "ngx-toastr";
import { UploadService } from "../../../../common/services/Upload.service";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs/Subscription";

// import services
import { EvsProductService } from "../../../../common/services/EvsProduct.service";

declare var $: any;

@Component({
  selector: "evs_product_variant",
  styleUrls: ["./product.css"],
  templateUrl: "./product_variant.component.html",
  providers: [EvsProductService],
})
export class EvsProductVariantComponent implements OnInit {
  @Input("idProduct") idProduct: any;
  @Output("backToList") backToList = new EventEmitter();
  listVariant: any = [];
  modalRef: BsModalRef;
  variantForm: FormGroup;
  searchForm: FormGroup;
  isAddVariant: boolean = false;
  isEditVariant: boolean = false;

  langSubscription: Subscription;
  placeholders: any = {};
  currentLang: string = 'vi';

  constructor(
    private productService: EvsProductService,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private upload: UploadService,
    private fb: FormBuilder,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.currentLang = this.translate.currentLang || 'vi';
    this.updatePlaceholders();
    this.langSubscription = this.translate.onLangChange.subscribe((event: any) => {
      this.currentLang = event.lang;
      this.updatePlaceholders();
    });

    this.getListVariant();
    this.createForm();
    this.createSearchForm();
  }

  createForm() {
    this.variantForm = this.fb.group({
      image: [null],
      serialVariant: [null, [Validators.required]],
      idExtra: [null],
    });
  }

  createSearchForm() {
    this.searchForm = this.fb.group({
      serial: [null],
    });
  }

  updatePlaceholders() {
    this.translate.get([
      'PV_NHAP_SERIAL'
    ]).subscribe((t: any) => {
      this.placeholders = {
        serial: t['PV_NHAP_SERIAL']
      };
    });
  }

  // get list product variant
  limit: number = 10;
  offset: number = 0;
  currentPage: number = 1;
  totalPage: number;
  getListVariant(query: any = null) {
    let option: any = {};
    option.limit = this.limit;

    if (query) {
      option.extra = query.extra;
      this.currentPage = 1;
      option.offset = 0;
    } else {
      option.offset = this.limit * (this.currentPage - 1);
    }

    this.productService
      .getListVariant(this.idProduct, option)
      .toPromise()
      .then((res) => {
        if (!res.error && res.data.count.count) {
          this.totalPage = Math.ceil(res.data.count.count / this.limit);
          this.listVariant = res.data.products;
        }
      });
  }

  // search
  searchVariant(data) {
    let query = {
      extra: data.serial,
    };
    this.getListVariant(query);
  }

  // set page pagination
  setPage(page: any) {
    if (page <= this.totalPage) {
      if (page < 1) {
        page = 1;
      } else if (page > this.totalPage) {
        page = this.totalPage;
      }

      if (page != this.currentPage) {
        this.currentPage = page;
        this.getListVariant();
      }
    } else {
      this.currentPage = this.totalPage;
      this.getListVariant();
      this.toastr.warning(this.translate.instant("PV_SO_TRANG_TOI_DA_LA") + this.totalPage, "", {
        timeOut: 3000,
        positionClass: "toast-bottom-right",
      });
    }
  }
  goToSetPage(page: any) {
    let _page = parseInt(page);
    if (_page && _page > 0) {
      this.setPage(_page);
    }
  }

  // open modal
  titleModal: string;
  openModal(
    template: TemplateRef<any>,
    type: string = "add",
    data: any = null
  ) {
    if (type == "add") {
      this.titleModal = "PV_THEM_BIEN_THE_MOI";
      this.variantForm.reset();
    }
    if (type == "edit") {
      this.titleModal = "PV_CAP_NHAT_BIEN_THE";
      if (data) {
        let image = {
          id: data.id,
          url: data.image,
        };
        this.variantForm.controls.image.setValue(image);
        this.variantForm.controls.serialVariant.setValue(data.extra);
        this.variantForm.controls.idExtra.setValue(data.id);
      }
    }
    this.modalRef = this.modalService.show(template);
  }

  // go back
  goBack() {
    this.backToList.emit({
      isBack: true,
    });
  }

  // handle images when upload
  tusUpload = (item) => {
    const numberImages = item.target.files.length;
    if (numberImages > 1) {
      this.toastr.error(this.translate.instant("PV_CHI_UPLOAD_1_ANH"), "", {
        timeOut: 4000,
        positionClass: "toast-bottom-right",
      });
    } else {
      for (const image of item.target.files) {
        const fileData = new FormData();
        // @ts-ignore
        fileData.append('file', image);
        return this.upload.uploadImagesNew2(fileData).subscribe((response: any) => {
          const res = JSON.parse(response._body)
          if (res.status === 200) {
            const image2 = {
              id: res.data.fileId,
              url: res.data.url,
            };
            if (image2) {
              this.variantForm.controls.image.setValue(image2);
            } else {
              this.toastr.error(this.translate.instant("PV_CO_LOI_XAY_RA"), "", {
                timeOut: 4000,
                positionClass: "toast-bottom-right",
              });
            }
          }
        });

      }
    }
  };

  // delete image upload
  deleteImage() {
    this.variantForm.controls.image.setValue(null);
    $("#tusUpload").val("");
  }

  // add new variant
  submitForm(data) {
    let request: any = {};

    request.image = data.image && data.image.url ? data.image.url : null;
    request.extra = data.serialVariant;

    if (data.idExtra) {
      this.productService
        .updateProductVariant(this.idProduct, data.idExtra, request)
        .subscribe((res) => {
          if (!res.error) {
            this.toastr.success(this.translate.instant("PV_CAP_NHAT_BIEN_THE_THANH_CONG"), "", {
              timeOut: 4000,
              positionClass: "toast-bottom-right",
            });
            this.getListVariant();
            this.modalRef.hide();
            this.createForm();
          }
        });
    } else {
      this.productService
        .addProductVariant(this.idProduct, request)
        .subscribe((res) => {
          if (!res.error) {
            this.toastr.success(this.translate.instant("PV_THEM_BIEN_THE_THANH_CONG"), "", {
              timeOut: 4000,
              positionClass: "toast-bottom-right",
            });
            this.getListVariant();
            this.modalRef.hide();
            this.createForm();
          }
        });
    }
  }

  // delete variant
  deleteProductVariant(idVariant: any) {
    this.productService
      .deleteProductVariant(this.idProduct, idVariant)
      .subscribe((res) => {
        if (!res.error) {
          this.toastr.success(this.translate.instant("PV_XOA_BIEN_THE_THANH_CONG"), "", {
            timeOut: 4000,
            positionClass: "toast-bottom-right",
          });
          this.getListVariant();
        } else {
          this.toastr.error(this.translate.instant("PV_CO_LOI_XAY_RA"), "", {
            timeOut: 4000,
            positionClass: "toast-bottom-right",
          });
        }
      });
  }

  ngOnDestroy() {
    if (this.langSubscription) {
      this.langSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/product/product_variant.component.ts